import * as React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import { DialogContent } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";

import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import InputLabel from "@mui/material/InputLabel";
import Select from "react-select";

function SelectActivityListsDialog({
  title,
  onClose,
  onOK,
  open,
  activities,
  showCreatePass = false,
}) {
  const [_selectedList, setSelectedList] = React.useState("XX");
  const [_isCreateHallPassChecked, setCreateHallPassChecked] = React.useState(false);

  const handleClose = () => {
    onClose();
  };

  const handleOK = () => {
    onOK(_selectedList, _isCreateHallPassChecked);
  };

  const handleSelect = (value) => {
    console.log(value);
    setSelectedList(value);
  };

  const handleChangeCreatePass = (event) => {
    console.log(event.target.value);
    setCreateHallPassChecked(event.target.checked);
  }

  return (
    <Dialog
      PaperProps={{
        sx: {
          maxWidth: 450,
        },
      }}
      onClose={handleClose}
      open={open}
      aria-labelledby="select-student-list-dialog-title"
      aria-describedby="select-student-list-dialog-description"
    >
      <DialogTitle id="select-student-list-dialog-title">{title}</DialogTitle>

      <DialogContent>
        <InputLabel>Transfer Student To Activity:</InputLabel>
        <Select
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          options={activities}
          onChange={handleSelect}
        />

        {showCreatePass === true && (
          <>
            <FormControlLabel
              sx={{mt:2}}
              control={
                <Checkbox
                  sx={{ pt: 0, pb: 0 }}
                  checked={_isCreateHallPassChecked}
                  className="chkPresent"
                  onChange={(event) => {
                    handleChangeCreatePass(event);
                  }}
                />
              }
              label={`Create Hall Pass`}
            />
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button variant="contained" onClick={handleOK}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SelectActivityListsDialog;
